import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { createdImagesActions } from '../../actions';
import {
  ChangeSwapActionPayload,
  UpdateSwapActionPayload,
} from '../../typedefs';

export function* updateSwap({
  payload,
}: PayloadAction<UpdateSwapActionPayload>) {
  try {
    yield effects.put(createdImagesActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.patch, [
      { endpoint: `image-studio/face-swaps/${payload.id}/`, body },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: ChangeSwapActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(createdImagesActions.changeSwap(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(createdImagesActions.stopFetching());
  }
}
